import React from 'react'
import { Col, Modal, Row } from 'react-bootstrap'
import ColumnChart from '@components/pages/Dashboard/Charts/ColumnChart.component'
import {
  LBData,
  colorsLB,
  leaderBoardData,
  seriesNamesLB,
} from '@components/pages/Dashboard/DashboardMockData'
import DashboardTable from '@components/pages/Dashboard/DashboardTable.component'

type YesterdaySideModalProps = {
  isOpen: boolean
  toggleModal: () => void
}

function YesterdaySideModal({
  isOpen,
  toggleModal,
}: YesterdaySideModalProps): React.ReactElement {
  const providerTemplate = (patient: any): React.ReactElement => {
    return (
      <div>
        <span>
          <i className="bi bi-circle-fill me-1 text-gray1"></i>
        </span>
        {`${patient.provider}`}
      </div>
    )
  }
  const column = [
    { field: 'rank', header: 'Rank' },
    {
      field: 'provider',
      header: 'Provider',
      isDropdown: false,
      template: providerTemplate,
    },
    {
      field: 'goal',
      header: 'Goal',
    },
    {
      field: 'actual',
      header: 'Actual',
    },
  ]

  return (
    <Modal show={isOpen} onHide={toggleModal} className="yesterday-side-modal">
      <Modal.Header className="bg-custom3" closeButton>
        <Modal.Title className="text-white">{`Leader board`}</Modal.Title>
      </Modal.Header>
      <Modal.Body className="">
        <Row>
          <Col md={12}>
            <h3 className="mb2">Two weeks performance</h3>
            <ColumnChart
              title={'leader-board'}
              data={leaderBoardData}
              seriesNames={seriesNamesLB}
              colors={colorsLB}
              maximum={100}
              minimun={40}
              interval={10}
            />
          </Col>
          <Col md={12}>
            <h3 className="mb2">Leader board</h3>
            <DashboardTable
              title={'leader-board'}
              data={LBData}
              columns={column}
              allowMultiSorting={false}
              allowSorting={false}
            />
          </Col>
        </Row>
      </Modal.Body>
    </Modal>
  )
}

export default YesterdaySideModal
